import React from 'react';
import { registerWidget } from '@okapi/core';
import { getGlobalRouter } from '@okapi/router-react';
import { State } from 'store/types';
import { ENTRANCE_DOORS_LANDING_NAME } from 'landings/entrance-doors';
import { EntranceDoorsRemote } from '../../common/widgets';
import { initWidgetDataWithShops } from '../init-widget-data-with-shops';

registerWidget<State, Record<string, string>>(`${__NAME__}/${ENTRANCE_DOORS_LANDING_NAME}`, state => {
  const router = getGlobalRouter();
  const store = initWidgetDataWithShops(state);

  return remoteProps => <EntranceDoorsRemote router={router} store={store} {...remoteProps} />;
});
